import React  from 'react';
import { ApiUrl } from '../../../project/Defines.js';
import { T } from '../../../components/Translations'
import ListView from '../../../Shared/ListView';
import { COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { useTranslation } from 'react-i18next';

/**
 * the Popup content of the BOM picker for product
 * @exports ProductBOMPicker
 */
export default function ProductBOMPicker(props) {
    const { t } = useTranslation("defines");
    const { updateData } = props;
    const columnConfig = [
        {
            text: 'text.reference',
            field: 'reference',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.name',
            field: 'nom',
            type: COLUMN_TYPE.TEXT
        },
        {
            type: COLUMN_TYPE.ACTION,
            width: t('width.action_select'),
            render: (text, record) =>
                <elastic>
                    <action hover="">
                        <div effect="material" className="button accent" onClick={() => { updateData(record); }}><text><T>text.select</T></text></div>
                    </action>
                </elastic>
            //commands: [{
            //    command: 'select', onClick: () => { alert('done'); }, }]
        },
    ];

    return (
        <ListView
            {...props}
            isSimple
            skipNewButton
            columnConfig={columnConfig}
            apiUrl={ApiUrl.BillOfMaterialList}
            search={{ field: 'search' }} />
    );
}
